import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules'

class ProductCarouselModule {
    constructor(selector) {
        this.selector = selector;
        this.swipers = [];

        this.initSliders();
        this.updateSliders = this.updateSliders.bind(this);
        window.addEventListener('resize', this.updateSliders);
    }

    initSliders() {
        const containers = document.querySelectorAll(this.selector);

        containers.forEach((container) => {
            const swiperInstance = new Swiper(container, {
                modules: [Navigation],
                slidesPerView: 'auto',
                spaceBetween: 0,
                centeredSlides: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        centeredSlides: false,                        
                    },
                },                
            });

            this.swipers.push(swiperInstance);
        });

        this.updateSliders();
    };

    updateSliders() {
        this.swipers.forEach((swiper) => {
            swiper.update();
        });
    }
}

export default ProductCarouselModule;
